import { useEffect, useState } from "react";
import AdminBoxConent from "../../components/admin/AdminBoxContent";
import SignupInvitation from "../../models/signupInvitation";
import userService from "../../services/userService";
import { useNavigate } from "react-router-dom";
import Moment from "react-moment";
import dateTimeHelper from "../../util/dateTimeHelper";
import ModalWindow from "../../components/common/overlays/ModalWindow";
import SignupUserStatus from "../../models/signupUserStatus";

const SignupInvitations: React.FC = () => {
  const navigate = useNavigate();

  const [signupInvitations, setSignupInvitations] = useState<
    SignupInvitation[]
  >([]);

  const [
    showDeleteSignupInvitationWindow,
    setShowDeleteSignupInvitationWindow,
  ] = useState<boolean>(false);

  const [signupInvitationDelete, setSignupInvitationDelete] =
    useState<SignupInvitation>();

  const init = async () => {
    const { data: signupInvitations } =
      await userService.getSignupInvitations();

    setSignupInvitations(signupInvitations);
  };

  useEffect(() => {
    init();
  }, []);

  const onInviteUsers = () => {
    navigate("/admin/invitations/invite");
  };

  const onApproveAccountConfirm = (signupInvitation: SignupInvitation) => {
    setShowDeleteSignupInvitationWindow(true);
    setSignupInvitationDelete(signupInvitation);
  };

  const onDeleteSignupInvitationCancel = () => {
    setShowDeleteSignupInvitationWindow(false);
    setSignupInvitationDelete(undefined);
  };

  const onDeleteSignupInvitationOk = async () => {
    setShowDeleteSignupInvitationWindow(false);

    if (!signupInvitationDelete) {
      return;
    }

    await userService.deleteSignupInvitation(
      signupInvitationDelete.idSignupInvitation
    );

    await init();

    setSignupInvitationDelete(undefined);
  };

  const statusToBadgeClass = (status: SignupUserStatus) => {
    let badgeTypeClass = "";

    switch (status) {
      case SignupUserStatus.Invited:
        badgeTypeClass = "bg-primary";
        break;

      case SignupUserStatus.Registered:
        badgeTypeClass = "bg-success";
        break;

      case SignupUserStatus.Unsubscribed:
        badgeTypeClass = "bg-danger";
        break;

      default:
        break;
    }

    return "badge " + badgeTypeClass;
  };

  return (
    <AdminBoxConent
      title="Invitations"
      hasCount={true}
      count={signupInvitations.length}
      countType="invitations"
      hasAddNew={true}
      addNewTitle="Invite Users"
      onAddNew={() => onInviteUsers()}
      hasCurrentOrganizationDropdown={false}
    >
      <table className="table table-hover horizontal-center-td">
        <thead>
          <tr>
            <th scope="col">Organization</th>
            <th scope="col">Email</th>
            <th scope="col">First Name</th>
            <th scope="col">Last Name</th>
            <th scope="col">Invitation Date</th>
            <th scope="col">Registration Date</th>
            <th scope="col">User Status</th>
            <th scope="col" style={{ width: "150px" }}></th>
            {/* <th scope="col">User Tags</th> */}
          </tr>
        </thead>
        <tbody>
          {signupInvitations.map(
            (signupInvitation: SignupInvitation, indexInvitation) => (
              <tr key={indexInvitation.toString()}>
                <td>{signupInvitation.organization?.organizationName}</td>
                <td>{signupInvitation.email}</td>
                <td>{signupInvitation.firstName}</td>
                <td>{signupInvitation.lastName}</td>
                <td>
                  <Moment format={dateTimeHelper.dateTimeFormat}>
                    {signupInvitation.invitationDate}
                  </Moment>
                </td>
                <td>
                  {signupInvitation.signupDate && (
                    <Moment format={dateTimeHelper.dateTimeFormat}>
                      {signupInvitation.signupDate}
                    </Moment>
                  )}
                  {!signupInvitation.signupDate && "-"}
                </td>
                <td>
                  <div
                    className={statusToBadgeClass(
                      signupInvitation.signupUserStatus
                    )}
                    style={{ textTransform: "uppercase", fontSize: "12px" }}
                  >
                    {signupInvitation.signupUserStatus}
                  </div>
                </td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => onApproveAccountConfirm(signupInvitation)}
                  >
                    Delete Invitation
                  </button>
                </td>
                {/* TODO maybe show the Invitation tag is mapped in Tag Mapping */}
                {/* <td>
                {signupInvitation.userTags.map((userTag, indexTag) => (
                  <span
                    key={`${indexInvitation}_${indexTag}`}
                    // style={{ textWrap: "nowrap" }}
                    className="user-tag me-2"
                  >
                    {userTag.tagName}
                  </span>
                ))}
              </td> */}
              </tr>
            )
          )}
        </tbody>
      </table>
      {showDeleteSignupInvitationWindow && (
        <ModalWindow
          title="Delete Invitation"
          onOk={onDeleteSignupInvitationOk}
          onCancel={onDeleteSignupInvitationCancel}
        >
          <div>
            Are you sure you want to delete the invitation for:{" "}
            <b>{signupInvitationDelete?.email}</b>?
          </div>
        </ModalWindow>
      )}
    </AdminBoxConent>
  );
};

export default SignupInvitations;
